import AsyncStorage from '@react-native-async-storage/async-storage';
import {removeDataFromStorage} from '@mmt/legacy-commons/AppState/LocalStorage'
import { isUserLoggedIn } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
import isUndefined from 'lodash/isUndefined';
import {Platform} from 'react-native';
import { getFcPrefCache } from 'apps/rails/src/RailsAbConfig'
import railsConfig, { AUTHORIZATION_KEY } from '../RailsConfig';
import { showShortToast } from '@mmt/legacy-commons/Common/Components/Toast';
import fetch2 from '../fetch2';
import { setCookie, getCookieValue } from './CommonUtils';
import { _label } from "../vernacular/AppLanguage";
import { getNewUniquePnrsHistory, getUniquePnrsFromStorage, saveUniquePnrsHistory } from './RisUtils';
import { OPTION_CATEGORY_TYPE } from '../pages/NewListing/Components/ConnectedTravel/Utils/ConnectedTravelUtils';

export const API_TIMEOUT = 60; //60 Seconds TODO: Get value from config store
export const SEO_REDIRECTIONS_API_TIMEOUT = 5;

export const ORG = 'MakeMyTrip';
export const LOB = 'Rails';
export const LISTING_PAGE_CONST = 'LISTING';
export const RAILS_LISTING = 'rails_listing';
export const LANDING_PAGE_CONST = 'landing';
export const RAILS_LANDING_PAGE_PREMIER_CONST = 'mob_rail_landing';
export const REVIEW_PAGE_CONST = 'REVIEW';
export const DATE_CHANGE_ERR_PAGE_CONST = 'DATE_CHANGE_ERR_PAGE';
export const PNR_RETURN_TICKETS = 'PNR_RETURN_TICKETS';
export const MAX_DAYS = 63; // ARP days
export const AUTO_COMPLETE_SEACH_LIMIT = 10;
export const CHILD_MIN_AGE = 5;
export const CHILD_MAX_AGE = 11;
export const SENIOR_CITIZEN_MALE_MIN_AGE = 60;
export const SENIOR_CITIZEN_TRANSGENDER_MIN_AGE = 60;
export const SENIOR_CITIZEN_FEMALE_AGE = 58;
export const SENIOR_CITIZEN_MAX_AGE = 125;
export const MIN_TRAVELLER_NAME_LENGTH = 3;
export const MAX_TRAVELLER_NAME_LENGTH = 16;
export const MAX_INFANT_ALLOWED = 2;
export const TRAVELLER_DETAILS = 'Traveller Details';
export const NO_RESERVATION_CHOICE_CODE = '99';
export const AVAILABLE_STATUS = 'AVAILABLE';
export const TRAVELLERS_PAGE_CONTEXT = 'TRAVELLERS_PAGE_CONTEXT';
export const BOTTOMSHEET_CONST = 'bottomsheet';
export const FULL_PAGE_CONST = 'full_page';
export const TRAIN_LABEL = 'VIEW TRAINS';
export const STUCK_IN_TEXT = 'Stuck in';
export const WAITING_LIST_TEXT = ' Waiting List ';
export const DEFAULT_TG_MARKETING_COUPON = 'MMTTRAIN';
export const WHY_BOOK_WITH_US = 'WHY BOOK WITH US?';
export const THREE_TIMES_REFUND = 'What is 3x refund?';

export const EXPAND_CONST = 'expand';
export const COLLAPSE_CONST = 'collapse';

export const RAILS_LANDING_PAGE_OFFERS_CARDS = 'offer';
export const RAILS_LANDING_PAGE_RECENT_BOOKING_CARDS = 'recentBooking';
export const RAILS_LANDING_PAGE_RETURN_TICKET_CARDS = 'returnTickets'
export const RAILS_LANDING_PAGE_COVID_CARDS = 'covidNotice';
export const RAILS_LANDING_PAGE_ADS_CARDS = 'ads';
export const RAILS_LANDING_PAGE_RECENT_SEARCHES_CARDS = 'recentSearch';
export const RAILS_LANDING_PAGE_MMT_HIGHLIGHTS = 'mmtHighlights';
export const RAILS_LISTING_PAGE_MMT_HIGHLIGHTS = 'rails_listing_highlight_banners';
export const RAILS_LANDING_PAGE_ANNOUNCEMENTS_CARDS = 'announcements';
export const RAILS_LANDING_PAGE_EXCLUSIVE_PARTNERS_CARDS = 'exclusivePartners';
export const RAILS_LANDING_PAGE_TRAVEL_GUIDELINE_CARD = 'travelGuideline';
export const PAGE_NOT_LOADING = 'pageNotLoading';
export const MAINTAINENCE_ERROR = 'maintenanceError';
export const EXPLORE_OPTIONS = 'Exploring other options Please wait!';

export const MWEB_LISTING = "https://www.makemytrip.com/railways/listing";
export const getRailsListingUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.href.includes("alliances.makemytrip") 
      ? "https://alliances.makemytrip.com/railways/listing" 
      : "https://www.makemytrip.com/railways/listing";
  }
  return "https://www.makemytrip.com/railways/listing";
};

export const RIS_LIVE_STATION_URL = 'https://www.makemytrip.com/rails/live-station-details/';
export const RIS_TRAIN_ROUTE_URL = 'https://www.makemytrip.com/rails/scheduleDetail';
export const CALENDAR_HOLIDAY_LIST_URL =
  'https://connect.makemytrip.com/mobile-core-api-web/api/holidayCalendar/v1/';
export const CALENDAR_HOLIDAY_LIST_API_KEY = 'and-059e174a-7874-4b0b-825f-ac28ac66625c';

export const NON_AC = 'Non-AC';
export const AC = 'AC';

export const CURRENCY_INR = 'INR';
export const PRODUCT_TYPE_TRAIN = 'train';
export const LOB_RAILS = 'rails';

export const ADDON_TYPE_FC = 'FC';
export const ADDON_TYPE_TG = 'TG';
export const ADDON_TYPE_BNPP = 'BNPP';
export const ADDON_TYPE_FREE_CANCELLATION = 'free_cancellation';
export const ADDON_TYPE_TRIP_GUARANTEE = 'trip_guarantee';
export const HEADING_FREE_CANCELLATION = 'Free Cancellation';
export const HEADING_TRIP_GUARANTEE = 'Trip Guarantee';

export const PAGE_TYPE_FUNNEL = 'funnel';
export const PAGE_LOAD_COMPONENT_TYPE = 'page_load';
export const COMPONENT_TYPE_MMT_LISTING_CAROUSEL_DATA = 'mmt_listing_carousel_data';

export const PAGE_NAME_LANDING = 'landing';
export const PAGE_NAME_LISTING = 'listing';
export const PAGE_NAME_TRAVELLER = 'detail';
export const PAGE_NAME_HOME = 'home';
export const PAGE_NAME_REVIEW = 'review';
export const PAGE_NAME_PAYMENT = 'payment';
export const PAGE_NAME_THANKYOU = 'thankyou';

export const LISTING_PAGE_LOAD_ID = 'listing_page_load';
export const XDM_THANKYOU_LOAD_ID = 'thankyou_load';

export const EVENT_NAME_PAGE_RENDERED = 'page-rendered';
export const EVENT_NAME_BUTTON_CLICKED = 'button-clicked';
export const EVENT_TYPE_PAGE = 'page';
export const EVENT_VALUE_LANDING_LOAD = 'LANDING_LOAD';

export const STORE_ID_MMT = 'MMT';
export const ORGANISATION_MMT = 'MMT';
export const BU_GROUND_TRANSPORT = 'ground_transport';

export const ENV_DEV = 'dev';
export const ENV_PROD = 'prod';

export const SOURCE_OF_DATA_REVIEW = 'review';
export const DATA_SOURCE_IRCTC = 'IRCTC';
export const AVAILABILITY_LAST_UPDATED_TEXT = 'updated just now';

export const RESERVATION_TYPE_GENERAL = 'general';
export const RESERVATION_TYPE_TATKAL = 'tatkal';

export const GENDER_MALE = 'M';
export const GENDER_FEMALE = 'F';
export const GENDER_MALE_TEXT = 'MALE';
export const GENDER_FEMALE_TEXT = 'FEMALE';

export const TITLE_MR = 'Mr';
export const TITLE_MS = 'Ms';
export const TITLE_OTHER = 'O';

export const TRAVELLER_TYPE_ADULT = 'adult';
export const TRAVELLER_TYPE_CHILD = 'child';
export const TRAVELLER_TYPE_INFANT = 'infant';

export const BERTH_RESERVED = 'Berth reserved';
export const NO_BERTH_RESERVED = 'No berth reserved';
export const FULL_TICKET_FULL_BERTH = 'Full ticket (full berth)';
export const RESERVE_A_BERTH = 'Reserve a berth';
export const DONT_RESERVE_A_BERTH = "Don't reserve a berth";

export const FUNNEL_ENTRY_LANDING = 'landing';
export const TRAFFIC_SOURCE_ORGANIC = 'organic';

export const DATE_MONTH_YEAR_FORMAT = 'DD-MM-YYYY';
export const DOUBLE_DIGIT_DAY_WITH_MONTH_FORMAT = 'DD MMM, dddd';
export const DOUBLE_DIGIT_DATE_WITH_MONTH_FORMAT = 'DD MMM';
export const YEAR_MONTH_DATE_FORMAT = 'YYYYMMDD';
export const YEAR_MONTH_DATE_WITH_SEPERATOR = 'YYYY-MM-DD';

export const VARIANT_LANDING_USERFLOW_OLD_LISTING = 'landingUserflowOldListing';
export const VARIANT_LANDING_USERFLOW_NEW_LISTING = 'landingUserflowNewListing';
export const VARIANT_NEW_LISTING_TRAVELLER_USERFLOW = 'newListingTravellerUserflow';

export const IRCTC_PASSWORD = "IRCTC_PASSWORD_RECEIVED_ON_SMS";

export const SORTED_SECTION_LIST_WHEN_ORDER_API_FAILS = [
  RAILS_LANDING_PAGE_RECENT_BOOKING_CARDS,
  RAILS_LANDING_PAGE_OFFERS_CARDS,
  RAILS_LANDING_PAGE_ADS_CARDS,
  RAILS_LANDING_PAGE_MMT_HIGHLIGHTS,
  RAILS_LANDING_PAGE_RETURN_TICKET_CARDS,
  RAILS_LANDING_PAGE_RECENT_SEARCHES_CARDS,
  RAILS_LANDING_PAGE_ANNOUNCEMENTS_CARDS,
  RAILS_LANDING_PAGE_EXCLUSIVE_PARTNERS_CARDS,
  RAILS_LANDING_PAGE_TRAVEL_GUIDELINE_CARD
  // RAILS_LANDING_PAGE_COVID_CARDS,      // not in use currently uncomment if covid cards come in use again
];

export const TEST_ID_CONSTANTS = {
  TRAVELLER_DETAILS: 'travellerDetailsPage_',
};

export const ENTITY = {
  TBS_API: 'tbsWithAvailabilityAndRecommendation',
  SEARCH_API: 'searchWithAvailAndRecommendation',
  LISTING_ERROR_BOUNDARY: 'listingErrorBoundary',
  COMMON_ERROR_BOUNDARY: 'commonErrorBoundary',
  LANDING_ERROR_BOUNDARY: 'landingErrorBoundary',
  TRAVELLER_ERROR_BOUNDARY: 'travellerErrorBoundary',
  LISTING_ERROR_BOUNDARY_CATCH: 'listingErrorBoundaryCatch',
  IRCTC_ERRORS: 'irctcErrors',
  GENERIC_PDT_MEASUREMENT_PLATFORM_ERROR: 'genericPdtMeasurementPlatformError',
  LANDING_PDT_ERROR_MEASUREMENT_PLATFORM: 'landingNewPdtMeasurementPlatformError',
  LISTING_PDT_ERROR_MEASUREMENT_PLATFORM: 'listingNewPdtMeasurementPlatformError',
  TRAVELLER_PDT_ERROR_MEASUREMENT_PLATFORM: 'travellerNewPdtMeasurementPlatformError',
  REVIEW_PDT_ERROR_MEASUREMENT_PLATFORM: 'reviewNewPdtMeasurementPlatformError',
  THANKYOU_PDT_ERROR_MEASUREMENT_PLATFORM_SUCCESS: 'thankyouNewPdtMeasurementPlatformSuccessError',
  THANKYOU_PDT_ERROR_MEASUREMENT_PLATFORM_FAILURE: 'thankyouNewPdtMeasurementPlatformFailureError',
  CONNECTED_TRAVEL_ERROR_MEASUREMENT_PLATFORM: 'connectedTravelErrorMeasurementPlatform',
  LANDING_PAGE_FECHA_ERROR: 'landingPageFechaError',
  REVIEW_VISIT_LATER_OMNI_ERROR: 'reviewVisitLaterOmniError',
};

export const REVIEW_OMNITURE_ERROR_CODES = {
  a: '6001',
  b: '6002',
  c: '6003',
  d: '6004',
  e: '6005',
  f: '6006',
}

export const COMMON_LATENCY = {
  TOTAL: 'total',
  SEARCH_API: 'searchWithAvailAndRecommendation',
  FIRST_RENDER: 'first_render',
  OVERALL_RENDER: 'overall_render',
};

let RAILS_TRAVELLERS_PAGE_PROPS;

export const setTravellersPageProps = (props) => {
  RAILS_TRAVELLERS_PAGE_PROPS = props;
};

export const voucherState = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  NOT_ISSUED: 'NOT_ISSUED',
};

export const RAILS_CONNECTED_TRAVEL_POKUS_CONSTANTS = {
  1: {
    backendKey: ['junction'],
    omnitureKey: 'ctj',
  },
  2: {
    backendKey: ['routePlanner'],
    omnitureKey: 'ctr',
  },
  3: {
    backendKey: ["routePlanner", "junction"],
    omnitureKey: 'ctjr',
  },
};

export const CONNECTED_TRAVEL_V2_CONSTANTS = {
  TWO_TRAINS: {
    TEST_ID: 'ct_train_and_train_listing',
    TITLE: 'Train + Train',
  },
  TRAINS_AND_BUS: {
    TEST_ID: 'ct_train_and_bus_listing',
    TITLE: 'Train + Bus',
  },
}

export const dummyArpResponse = {
  avlDayList: [
    {
      availablityStatus: 'Train outside booking window'
    }
  ]
}

export const TRAIN_OUTSIDE_RESERVATION_WINDOW = "This action not allowed as the Date given is Outside Advance Reservation Period- (80012)\n";

export const TBS_STATUSES_TO_HANDLE = ['train departed', 'train cancelled', 'train outside booking window'];

export const dynamicPricingTrainTypes = ['SV', 'R', 'D', 'S'];

export const RAIL_LISTING_DATE_FORMAT = 'DD MMMM YYYY dddd';

export const INPUT_CITY_SELECTED = {
  source: 'SOURCE',
  destination: 'DESTINATION',
  defaults: 'DEFAULTS',
};

export const ASYNC_STORAGE_PREFIX = 'RAILS_';
export const RAILS_IRCTC_USERNAME = `${ASYNC_STORAGE_PREFIX}IRCTC_USERNAME`;
export const RAILS_CONFIG_DATA = `${ASYNC_STORAGE_PREFIX}CONFIG_DATA`;
export const RAILS_CONFIG_PERSISTED_DATA = `${ASYNC_STORAGE_PREFIX}_PERSISTED_CONFIG_DATA`;
export const TRAVELLER_PDT_ADDON_DETAILS = `${ASYNC_STORAGE_PREFIX}TRAVELLER_PDT_ADDON_DETAILS`;
export const LISTING_PDT_TRAIN_CARD_DETAILS = `${ASYNC_STORAGE_PREFIX}LISTING_PDT_TRAIN_CARD_DETAILS`;
export const RAILS_IRCTC_SHOW_PASSWORD_REMINDER_SCREEN =
  'RAILS_IRCTC_SHOW_PASSWORD_REMINDER_SCREEN';
export const RAILS_MMT_ID = `${ASYNC_STORAGE_PREFIX}MMT_ID`;
export const RAILS_BOOKING_ID = `${ASYNC_STORAGE_PREFIX}BOOKING_ID`;
export const RAILS_BOOKING_TIMER_START_TIME = `${ASYNC_STORAGE_PREFIX}BOOKING_TIMER_START_TIME`;
export const RAILS_BUS_COMMON_LANDING = `${ASYNC_STORAGE_PREFIX}RAILS_BUS_COMMON_LANDING`;
export const MWEB_HOST = 'MWEB_HOST';
export const REVIEW_TIMER = 'REVIEW_TIMER';
export const RAILS_CURR_AVL = 'CURR_AVL';
export const ITENERARY_DATA = `${ASYNC_STORAGE_PREFIX}ITENERARY_DATA`;
export const RAILS_API_ENV = `${ASYNC_STORAGE_PREFIX}API_ENV`;
export const RAILS_API_ENV_SELECTION = `${ASYNC_STORAGE_PREFIX}API_ENV_SELECTION`;
export const ITENERARY_ID = 'itenerary_id';
export const SENTRY_TRACE_ID = 'sentry_trace_id';
export const IRCTC_ACCOUNT_REGISTER_COUNT ='irctc_account_register_count';
export const CREATE_ACCOUNT_CLICK = 'create_account_click';
export const TG_LOW_CP_BUCKET_KEY = 'lowCpBucket';
export const HDFC_SMART_BUY_EVAR = 'h_sb';

const setInCookie = [RAILS_MMT_ID, MWEB_HOST];
export const RAILS_SESSION_ID = `${ASYNC_STORAGE_PREFIX}SESSION_ID`;
export const RAILS_IS_PRE_FC_SELECTED = `${ASYNC_STORAGE_PREFIX}_IS_PRE_FC_SELECTED`;
export const RAILS_FC_TG_SOCIAL_PROOFING = `${ASYNC_STORAGE_PREFIX}_FC_TG_SOCIAL_PROOFING`;
export const RAILS_GRAFANA_DATA = `${ASYNC_STORAGE_PREFIX}GRAFANA_DATA`;
export const RAILS_SESSION_ID_EXPIRY_IN_MINUTES = 40;
export const REVIEW_BUTTON_CLICK_COUNT = 'REVIEW_BUTTON_CLICK_COUNT';
export const RAILS_ERROR_RETRY_COUNT = `${ASYNC_STORAGE_PREFIX}_ERROR_RETRY_COUNT`;

export const BACK_TO_LISTING = 'BACK_TO_LISTING';
export const CLOSE_BOTTOMSHEET = 'CLOSE_BOTTOMSHEET';
export const RETRY = 'RETRY';
export const CONTINUE = 'CONTINUE';
export const WEBVIEW = 'WEBVIEW';
export const SET_ALERT = 'SET_ALERT';
export const DEEPLINK = 'DEEPLINK';
export const CALL_API = 'CALL_API';

export const BUILD_FLAVOR = {
  CHARLES: 'standard_charles',
};

export const AADHAR_VERIFICATION_ERROR_CODE = 'RAILS_BOOKING_REVIEW_TQ_AADHAAR_NV_ERROR';
export const TICKET_CHARGE = 'Ticket Charge';
export const RAIL_TRACKING_DATA_EVAR_47 = 'RAIL_TRACKING_DATA_EVAR_47';
export const AppInstallBannerFields = Object.freeze({
  heading: "download_app_for_offers" ,
  text: "get_app_exclusive_offers" ,
  buttonText: "install_app",
  deepLink: "https://app.mmyt.co/Xm2V/" ,
  omnitureData: {
      "propName": "prop67" ,
      "componentShowPropName": "prop67" ,
      "tracker": "trainslisting_appinstall_click" ,
      "componentShowTracking": "trainslisting_appinstall_shown"
  }
})

export const AppInstallBannerCss = {width:'90%',paddingTop:0,paddingBottom:0,height:'94%'};

export const railsListingBannerURL = (originStationCode,destinationStationCode,date) => (
  `appinstalltrainslisting?mmyt://react/?page=railsListing&to=${destinationStationCode}&departure=${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}&from=${originStationCode}&deeplink=true&cmp=pwa_trains_listing`
)

export const setDataToAsyncStorage = async (key, value) => {
  try {
    if (value === null || value === '' || value === undefined) return;
    if (Platform.OS === "web" && setInCookie.includes(key)) {
      setCookie(key, value);
      return;
    }
    await AsyncStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.log(`Set Data to local storage error : ${error}`);
  }
};

export const getDataFromAsynStorage = async (key) => {
  try { 
    if (Platform.OS === 'web' && setInCookie.includes(key)) {
      return getCookieValue(key);
    }
    const data = await AsyncStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
    return null;
  } catch (e) {
    console.log(`Get Data from local storage error:${e}`);
  }
};

export const removeDataFromAsyncStorage = async (key) => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (error) {
    console.error("Failed to remove item", key, "error.message");
  }
}

export const setDataToSessionStorageWithExpiry = async (key, value, expiryInMinutes = RAILS_SESSION_ID_EXPIRY_IN_MINUTES) => {
  if (value === null || value === '' || value === undefined) return;
  
  if (Platform.OS === "web") {
    const expiryTime = Date.now() + (expiryInMinutes * 60 * 1000);
    const dataWithExpiry = {
      value: value,
      expiry: expiryTime
    };
    window.sessionStorage.setItem(key, JSON.stringify(dataWithExpiry));
  }
};

export const getDataFromSessionStorageWithExpiry = async (key) => {
  if (Platform.OS === 'web') {
    const data = window.sessionStorage.getItem(key);
    if (data) {
      try {
        const parsedData = JSON.parse(data);
        if (parsedData && typeof parsedData === 'object' && parsedData.expiry) {
          if (Date.now() > parsedData.expiry) {
            window.sessionStorage.removeItem(key);
            return null;
          }
          return parsedData.value;
        }
        return parsedData;
      } catch (error) {
        console.log(`Session storage parse error: ${error}`);
      }
    }
    return null;
  }
  return null;
};

export const _isUserProfileServieAvailable = () => {
  const now = new Date();
  const start = new Date();
  start.setHours(9, 30, 0, 0);

  const end = new Date();
  end.setHours(11, 30, 0, 0);
  if (now >= start && now <= end) {
    showShortToast(_label("service_unavailable"));
    return false;
  }
  return true;
};


export const handleError = (message, exception) => {
  const errorMessage = `${_label("sorry_something_wrong")} ${message}`;
  if (!isUndefined(exception)) {
    console.log(exception);
  }
  showShortToast(errorMessage);
};

export const appendRupeeSymbol = (amount) => {
  try {
    return `₹ ${amount}`;
  } catch (e) {
    console.log('err', e);
  }
};

export const getRequestHeader = (mmtAuth) => {
  const userIdentifierJson = `{"type": "mmt-auth" ,"deviceId" : "deviceId", "os":"os", "osVersion":"osVersion", "appVersion":"appVersion", "imie":"imie", "ipAddress":"ipAddress", "timeZone":"timeZone", "value":"${mmtAuth}"}`;
  const requestHeader = {
    'Content-Type': 'application/json',
    Authorization: AUTHORIZATION_KEY,
    'User-Identifier': userIdentifierJson,
  };
  return requestHeader;
};

export const clearLocalStorageForCurrentTransaction = () => {
  const keys = [RAILS_BOOKING_ID, RAILS_MMT_ID, RAILS_BOOKING_TIMER_START_TIME];
  AsyncStorage.multiRemove(keys, (error) => {
    console.log('Error occured while clearing local storage for current transaction', error);
  });
};

const TATKAL_START_TIME = 10;
const TATKAL_END_TIME = 12;

export const isIRCTCTatkalTime = () => {
  const now = new Date();

  const start = new Date();
  start.setHours(TATKAL_START_TIME, 0, 0, 0);

  const end = new Date();
  end.setHours(TATKAL_END_TIME, 0, 0, 0);

  if (now >= start && now <= end) {
    return true;
  }
  return false;
};


export const removeFCKey = async () => {
  const prefCacheVal = await getFcPrefCache();
  if (!prefCacheVal) {
    removeDataFromStorage(RAILS_IS_PRE_FC_SELECTED)
  }
}

export const getEmailMobileNumberFromConfirmBookingApi = async (mmtId) => {
  try {
    const res = await fetch2(railsConfig.trainBookingStatus, {
      method: 'POST',
      body: JSON.stringify({
        bookingId: mmtId,
      }),
    });
    const response = await res.json();
    return {
      ...response,
      error: false,
    };
  } catch (e) {
    return {
      error: true,
    };
  }
};

export const getStatusWithBookingId = async (bookingId) => {
  try {
    const res = await fetch2(railsConfig.trainBookingStatus, {
      method: 'POST',
      body: JSON.stringify({
        bookingId,
      }),
    });
    const response = await res.json();
    return response;
  } catch (e) {
    console.log('Some error occured while fetching booking status', e);
  }
};

export const getDefaultHeadersWithMMTAuth = (mmtAuth) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'mmt-auth': mmtAuth,
});

export const npsRating = {
  header: 'Rate your Booking Experience?',
  subheader: 'Tell us how was your booking experience!',
  subHeading: {
    oneStar: "Oh! Too bad! Why don't you give us some feedback?",
    twoStar: "Oh! Too bad! Why don't you give us some feedback?",
    threeStar: "Umm! Looks like we are doing just okay! Why don't you give us your feedback?",
    fourStar: 'Yay! We are always trying to do our best!',
    fiveStar: 'Awesome! We will keep improving!',
  },
  successMsg: 'Thanks for your rating!',
  actionOn4: 'TY',
  abVarient: 'IARP',
  canEdit: true,
  lowRatingCta: [
    {
      type: 'LEFT',
      title: 'SKIP',
    },
    {
      type: 'RIGHT',
      title: 'FEEDBACK',
    },
  ],
  fourRatingCTA: [
    {
      type: 'LEFT',
      title: 'SKIP',
    },
    {
      type: 'RIGHT',
      title: 'SUBMIT',
    },
  ],
  fiveRatingCTA: [
    {
      type: 'LEFT',
      title: 'SKIP',
    },
    {
      type: 'RIGHT',
      title: 'SUBMIT',
    },
  ],
};


export const getNpsLabels = () => {
  return {
    header: _label("rate_your_booking_experience"),
    subheader: _label("tell_us_booking_experience"),
    subHeading: {
      oneStar: _label("oneStarText"),
      twoStar: _label("oneStarText"),
      threeStar: _label("threeStarText"),
      fourStar: _label("fourStarText"),
      fiveStar: _label("fiveStarText"),
    },
    successMsg: _label("thanksForFeedback"),
    actionOn4: 'TY',
    abVarient: 'IARP',
    canEdit: true,
    lowRatingCta: [
      {
        type: 'LEFT',
        title: 'SKIP',
      },
      {
        type: 'RIGHT',
        title: 'FEEDBACK',
      },
    ],
    fourRatingCTA: [
      {
        type: 'LEFT',
        title: 'SKIP',
      },
      {
        type: 'RIGHT',
        title: 'SUBMIT',
      },
    ],
    fiveRatingCTA: [
      {
        type: 'LEFT',
        title: 'SKIP',
      },
      {
        type: 'RIGHT',
        title: 'SUBMIT',
      },
    ],
  };
};

export const UNIQUE_PNR_PAGENAMES = {
  PNR_STATUS: 'PNR_STATUS',
  TGS_TRAVELLER: 'TGS_TRAVELLER',
  TGS_THANKYOU: 'TGS_THANKYOU',
  NEW_PNR_STATUS: 'PNR_STATUS_NEW',
  NEW_TGS_TRAVELLER: 'TGS_TRAVELLER_NEW',
  NEW_TGS_THANKYOU: 'TGS_THANKYOU_NEW',
  NEW_LANDING_PAGE:'PNR_LANDING_PAGE_NEW',
  LANDING_PAGE:'PNR_LANDING_PAGE',
  TGS_LANDING_PAGE:'TGS_LANDING_PAGE',
  TGS_THANK_YOU:'TGS_THANK_YOU'
}

export const RAILS_ERROR_FLOW = {
  ERROR_HANDLING_ON: 'eh',
  ERROR_HANDLING_OFF: 'ehn',
};

export const RAILS_LISTING_RETRY = {
  RETRY_ON: 'ehl',
  RETRY_OFF: 'ehnl',
}

export const pageNameRanking = (pageName) => {
  switch (pageName) {
    case UNIQUE_PNR_PAGENAMES.PNR_STATUS: return 1;
    case UNIQUE_PNR_PAGENAMES.TGS_TRAVELLER : return 2;
    case UNIQUE_PNR_PAGENAMES.TGS_THANKYOU : return 3;
  }
}

export const isUniquePnrVisit = async (pageName, pnrNumber, travelEndDate = '') => {
  if (!pnrNumber) {
    return false;
  }

  const uniquePnrsList = await getUniquePnrsFromStorage();
  const currentPnrFromList = uniquePnrsList?.find((uniquePnr) => {
    const pnrNumberFromList = uniquePnr.pnrNumber;
    if(pnrNumber === pnrNumberFromList) {
      return uniquePnr;
    }
  })
  const visitedNewPage = pageNameRanking(pageName) > pageNameRanking(currentPnrFromList?.pageName);

  if(!currentPnrFromList || visitedNewPage) {
      const currentPnr = {
        pnrNumber: pnrNumber,
        pageName: pageName,
        travelEndDate: currentPnrFromList?.travelEndDate || travelEndDate,
      };
      const recentUniquePnrsHistory = getNewUniquePnrsHistory(currentPnr, uniquePnrsList || null);
      if (recentUniquePnrsHistory) {
        await saveUniquePnrsHistory(recentUniquePnrsHistory);
      }
    return true;
  }
  return false;
}


// HYDRA API CONSTANTS START
export const ACCEPT_ENCODING_HEADER_NAME  = 'Accept-Encoding';
export const GZIP_ENCODING = 'gzip';
export const CONTENT_TYPE_HEADER_NAME = 'Content-Type';
export const CONTENT_TYPE = 'application/json';
export const API_KEY_HEADER_NAME = 'apikey';
export const API_KEY =  'b88e435f135bd4c42584d4887189d638b1ab9eaa';
export const HOST_HEADER_NAME = 'Host' ;
export const HYDRA_HOST_URL = 'dpt-fsbrokerapi.ecs.mmt';
export const HYDRA_SERVICE_NAME = "service";
export const HYDRA_SERVICE_VALUE =  "hydra";
export const HYDRA_SEGMENTS_NAME = "segments";
export const HYDRA_SEGMENT_RAILS = "r1145"
export const USER_ID_HEADER_NAME = 'user_id';
export const PROFILE_TYPE_HEADER_NAME = 'profile_type';
export const MMT_AUTH_HEADER_NAME = 'mmt-auth';
// HYDRA API CONSTANTS END

//Speed constant
export const SPEED_STATUS = {
  ON_TIME:'ON_TIME',
  DELAY: 'DELAY',
  PLANNED_HALT: 'PLANNED_HALT',
  UNPLANNED_HALT: 'UNPLANNED_HALT',
  NA: 'NA',
};

const RAIL_TRACKING_PREFIX = "mob_rail";

const LANDING_PAGE_TRACKING_KEY = `${RAIL_TRACKING_PREFIX}_landing`;
const TRAVELER_PAGE_TRACKING_KEY = `${RAIL_TRACKING_PREFIX}_traveller`;
export const TRAVELERS_PAGE_TRACKING_KEY_NEW = `${RAIL_TRACKING_PREFIX}_travellers`;
const TRAVELER_CONTACT_DETAILS_REDESIGN = `${TRAVELER_PAGE_TRACKING_KEY}_cd`
export const REVIEW_PAGE_TRACKING_KEY = 'mob_rail_review';
export const pageNameArray = ['addTraveler', 'railsForgotUsername', 'createIRCTCAccount'];

export const LANDING_FILTER_COMPONENT_NAME = `${LANDING_PAGE_TRACKING_KEY}_filter_class`;
export const LISTING_HEADER_BACK = `${LISTING_PAGE_TRACKING_KEY}_header_back`;
export const LISTING_CONFIRMEDOPTIONS = `${LISTING_PAGE_TRACKING_KEY}_confirmedoptions`;
export const LISTING_CONFIRMEDOPTIONS_BACK = `${LISTING_PAGE_TRACKING_KEY}_confirmedoptions_back`;
export const LISTING_CLUSTERBOTTOMSHEET = `${LISTING_PAGE_TRACKING_KEY}_clusterbottomsheet`;
export const LISTING_NEARBYSTATIONS = `${LISTING_PAGE_TRACKING_KEY}_nearbystations`;
export const TRAVELER_HEADER_BACK = `${TRAVELER_PAGE_TRACKING_KEY}_header_back`;
export const TRAVELER_DETAILS_NOT_SELECTED = `${TRAVELER_PAGE_TRACKING_KEY}_travellerdetails_notselected`;
export const REGULAR_LOGIN_FLOW = 'regular_login';
export const TRAVELER_PASSENGER_DETAILS = `${TRAVELERS_PAGE_TRACKING_KEY_NEW}_passenger`;
export const TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET = `${TRAVELERS_PAGE_TRACKING_KEY_NEW}_pd`;

export const TRAVELER_PASSENGER_DETAILS_CHECKBOX = `${TRAVELER_PASSENGER_DETAILS}_name`;
export const TRAVELER_PASSENGER_DETAILS_VIEW_LIST = `${TRAVELER_PASSENGER_DETAILS}_view`;

export const TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET_NAME = `${TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET}_name`;
export const TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET_AGE = `${TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET}_age`;
export const TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET_BERTH_PREF = `${TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET}_berth_pref`;
export const TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET_DISMISS = `${TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET}_bottomsheet_dismiss`;
export const TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET_EDIT_DISMISS = `${TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET}_bottomsheet_edit_dismiss`;
export const TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET_EDIT_DELETE = `${TRAVELER_PASSENGER_DETAILS_BOTTOMSHEET}_bottomsheet_edit_delete_passenger`;

export const TRAVELER_CD_BS_EMAIL_SUCESSFULL = `${TRAVELER_CONTACT_DETAILS_REDESIGN}_email`;
export const TRAVELER_CD_BS_PHONE_SUCESSFULL = `${TRAVELER_CONTACT_DETAILS_REDESIGN}_phone`;
export const TRAVELER_CD_BS_MAIN_PHONE_INVALID = `${TRAVELER_CONTACT_DETAILS_REDESIGN}_phone_invalid`;
export const TRAVELER_CD_BS_MAIN_EMAIL_INVALID = `${TRAVELER_CONTACT_DETAILS_REDESIGN}_email_invalid`;
export const TRAVELER_CD_MAIN_CONTINUE_WITHOUT_EMAIL = `${TRAVELER_CONTACT_DETAILS_REDESIGN}_email_notprovided`;
export const TRAVELER_CD_MAIN_CONTINUE_WITHOUT_PHONE = `${TRAVELER_CONTACT_DETAILS_REDESIGN}_phone_notprovided`;
export const TRAVELER_CD_MAIN_CONTINUE_WITHOUT_PHONE_AND_EMAIL = `${TRAVELER_CONTACT_DETAILS_REDESIGN}_phone_email_notprovided`;

export const TRAVELER_COMPONENT_DEFAULT_ORDERING = 'bd1,irctc2,ln3,trav4,pref5,fc7,cd8,disc9';

export const LOGGED_OUT_COUPONS_NOT_SHOWN_POKUS_ZERO = 0;
export const LOGGED_OUT_COUPONS_NOT_SHOWN_POKUS_ONE = 1;
export const LOGGED_OUT_COUPONS_SHOWN_POKUS = 2;
export const LOGGED_OUT_COUPONS_NOT_SHOWN_POKUS_ZERO_OMNITURE = "lg_0";
export const LOGGED_OUT_COUPONS_NOT_SHOWN_POKUS_ONE_OMNITURE = "lg_1";
export const LOGGED_OUT_COUPONS_SHOWN_POKUS_OMNITURE = "lg_2";
export const LOGIN_TO_AVAIL_CLICKED = "mob_rail_travellers_coupon_login";
export const LOGIN_TO_AVAIL_CLICKED_PERSIST = "lg_c";

export const REVIEW_FARE_BREAKUP_COLLAPSED = 'rail_review_fare_breakup_collapsed';
export const REVIEW_FARE_BREAKUP_EXPANDED = 'rail_review_fare_breakup_expanded';
export const LISTING_PAGE_TRACKING_KEY = 'mob_rail_listing_v2';
export const TRAVELERS_TG_ELIGIBILITY_CHANGE = 'mob_rails_review_TG_eligible';
export const TRAVELERS_FC_ELIGIBILITY_CHANGE = 'mob_rails_review_TG_to_FC';
export const LISTING_TRAIN_SCHEDULE = 'mob_rail_listing_train_schedule';
export const LISTING_TRAIN_SCHEDULE_WITH_ODT = 'rails_odt_schedule';
export const LISTING_TRAIN_SCHEDULE_DISMISS = 'mob_rail_listing_train_schedule_dismiss';
export const TRAVELER_BACK_RESISTANCE = 'rail_travelers_back_resistance';
export const REVIEW_BACK_RESISTANCE = 'rail_review_back_resistance';
export const TRAVELER_FC_PROMT = 'mob_rail_traveller_prompt_fc';
export const TRAVELER_FREE_CANCELLATION = 'mob_rail_traveller_FC';
export const TRAVELERS_FC_WIDGET_NEW = 'rails_fc_widget_new';
export const TRAVELERS_COMPONENT_ORDER = 'bd1,irctc2,ln3, trav4,ins6,fc7,pp,disc9,cd8,pref5,opgst';

export const SUCCESS_STATUS = 'S';
export const FAILURE_STATUS = 'F';

export const TRAVELER_DETAILS_FC_BOTTOMSHEET_CONTENT = {
  fcList: [
    'Enjoy ZERO IRCTC penalty',
    'Get FULL Ticket Fare Refund',
    'Automatic waiver on your cancellation',
    'Instant refund to your original pay mode',
  ],
  fcString: 'Cancel your Train bookings for FREE with Free Cancellation',
};

export const TRAVELER_DETAILS_FC_BOTTOMSHEET_CONTENT_WHEN_BNPP = {
  fcList: [
    '<p>Enjoy ZERO penalty</p>',
    '<p>Instant refund to your original pay mode</p>',
    //eslint-disable-next-line max-len
    '<p>With Free Cancellation, you can pay the remaining amount by <s>{dueDate}</s>, <pb>{fcDueDate}</pb>, <pb>{fcDueHour} hours</pb> before journey.</p>',
  ],
  fcString: 'Cancel your Train bookings for FREE with Free Cancellation',
  headerString: 'Get Full Ticket Fare Refund',
};

export const SEATLOCK_REVIEW_TRACKING_EVENTS = {
  SEATLOCK_REVIEW_OPTED: 'mob_rail_review_seatlock_yes',
  SEATLOCK_REVIEW_NOT_OPTED: 'mob_rail_review_seatlock_no',
  SEATLOCK_REVIEW_BOTTOM_SHEET_INFO: 'mob_rail_review_seatlock_ibutton',
  SEATLOCK_REVIEW_TNC_CLICK: 'mob_rail_review_seatlock_tnc_clicked',
};

export const IRCTC_PROFILE_INCOMPLETE_FLOW_EVENTS = {
  TRAVELLER: {
    COMPLETE_PROFILE_CLICK_BS: 'mob_rail_travellers_irctc_na_bs_cta',
    COMPLETE_PROFILE_CLICK_INLINE: 'mob_rail_travellers_irctc_na_complete_now',
    SUCCESSFUL_PROFILE_COMPLETION_CLICK_EVENT: 'mob_rail_travellers_irctc_na_success',
    UNSUCCESSFUL_PROFILE_COMPLETION_CLICK_EVENT: 'mob_rail_travellers_irctc_na_failed',
    SUCCESSFUL_PROFILE_COMPLETION_EVAR97_EVENT: 'na_st',
    PROFILE_INCOMPLETE_BS_LOAD: 'nab_L',
    COMPLETE_PROFILE_CLICK_EVAR99: 'na_c',
    IRCTC_PROFILE_INCOMPLETE_STATUS_EVAR99: 'n_auth',
    IRCTC_PROFILE_COMPLETE_STATUS_EVAR99: 't_auth',
    IRCTC_USERNAME_PREFILLED: 'pre_t',
    IRCTC_USERNAME_NOT_PREFILLED: 'pre_f',
    IRCTC_PROFILE_INCOMPLETE_FLOW_EVAR99_EVENT: 'nat_',
  },
  REVIEW: {
    BOTTOMSHEET_LOAD: 'mob_rail_review_irctc_profile_incomplete_bs_load',
    COMPLETE_PROFILE_CLICK: 'mob_rail_review_irctc_profile_incomplete_complete_profile_click',
    COMPLETE_PROFILE_CLICK_EVAR99: 'irctc_profile_incomplete_complete_profile_click',
    PROCEED_WITHOUT_COMPLETE_CLICK: 'mob_rail_review_irctc_profile_incomplete_proceed_without_complete_click',
  },
};

export const IRCTC_TATKAL_AADHAR_NOT_VERIFIED_ERROR_CODE =
  'IRCTC_TATKAL_AADHAAR_NOT_VERIFIED_ERROR';

export const SEATLOCK_VARIANTS = {
  VARIANT_1: 're_sl_1',
  VARIANT_2: 're_sl_2',
  VARIANT_3: 're_sl_3',
};

export const EMAIL_CONST = 'email';
export const MOBILE_CONST = 'mobile'
export const PRICE_REPLACER = '{price}';
export const REFUND_REPLACER = '{refund}';
export const FINAL_FARE_REPLACER = '{finalFare}';
export const DUE_AMOUNT_REPLACER = '{dueAmount}';
export const DUE_DATE_REPLACER = '{dueDate}';
export const FC_DUE_DATE = '{fcDueDate}';
export const FC_DUE_HOUR = '{fcDueHour}';
export const PAY_CUT_OFF_REPLACER = '{paymentCutOffTimeInHours}';
export const REMAINING_AMOUNT = '{remainingAmount}';
export const FROM_STATION_REPLACER = '{fromStation}';
export const TO_STATION_REPLACER = '{toStation}';

export const IRCTC_CREATE_ACCOUNT_EVENT = 'irctc_create_account';
export const IRCTC_CAPTCHA_RETRY_EVENT = `rails_${IRCTC_CREATE_ACCOUNT_EVENT}_captcha_retry`;
export const IRCTC_CAPTCHA_FAILED_EVENT = `rails_${IRCTC_CREATE_ACCOUNT_EVENT}_captcha_failed`;
export const IRCTC_ENTER_VALID_DETAILS_RED_FLAG = `rails_${IRCTC_CREATE_ACCOUNT_EVENT}_enter_valid_details_red_flag`;
export const IRCTC_ENTER_VALID_DETAILS_EVENT = `rails_${IRCTC_CREATE_ACCOUNT_EVENT}_enter_valid_details`;
export const IRCTC_SOMETHING_WENT_WRONG_EVENT = `rails_${IRCTC_CREATE_ACCOUNT_EVENT}_something_went_wrong`;
export const RIS_ON_CLICK_GPT_BANNER = 'ris:onClick_GPT_Banner'
export const RIS_ON_CLICK_GPT_LOTTIE = 'ris:onClick_GPT_Lottie';
export const RIS_FOOD_IN_TRAIN_PAGE_LOAD = 'ris_details_meals_shown';
export const PNR_STATUS_FOOD_IN_TRAIN_LOAD = 'pnr_details_meals_shown';
export const LTS_DETAILS_FOOD_IN_TRAIN_LOAD = 'lts_details_meals_shown';
export const LTS_DETAILS_MEALS_ORDER_NOW_STICKY_CLICKED =
  'lts_details_meals_order_now_sticky_clicked';
export const LTS_DETAILS_MEALS_ORDER_NOW_CLICKED = 'lts_details_meals_order_now_clicked';
export const LTS_DETAILS_MEALS_ORDER_NOW_BS_CLICKED = 'lts_details_meals_order_now_bs_clicked';
export const TRAIN_THANKYOU_MEALS_SHOWN = 'train_thank_you_meals_shown';
export const TRAIN_THANKYOU_MEALS_ORDER_NOW_CLICKED = 'train_thank_you_meals_order_now_clicked';
export const PNR_DETAILS_MEALS_ORDER_NOW_BS_CLICKED = 'pnr_details_meals_order_now_bs_clicked';
export const PNR_DETAILS_MEALS_BS_SHOWN = 'pnr_details_meals_bs_shown';
export const NEARBY_DATES_EVENTS = {
  availabilitySwitch: 'Rails:FAA_availability_switch',
  confirmedOptionsClick: 'rail_nearby_confirmed',
  sameDateClick: 'rail_nearby_same',
  otherDateClick: 'rail_nearby_other',
  sourceTrackingPrefix: 'nb_',
  retryClick: 'rails_error_faa_retry',
  retrySuccess: 'Rails:FAA_retry_success',
  nearByDatesVariant1: 'nb_cf_1',
  nearByDatesVariant2: 'nb_cf_2',
  nearByDatesVariant3: 'nb_cf_3',
  nearByDatesVariant4TooltipClicked: 'mob_rail_listing_mmtcnf_ibutton',
  tapToUpdateClick: 'mob_rail_listing_nb_ttu_clicked',
  tapToUpdateClickOutsideARP: 'mob_rail_listing_nb_ttu_arp_clicked',
};

export const LISTING_CONNECTED_TRAVEL_EVENTS = {
  expandClick: 'rails_connected_travel_expand',
  viewAllClicked: 'rails_connected_travel_view_all_options',
  cardClick: 'rails_connected_travel_card_clicked',
  cardClickRecommended:'rails_connected_travel_recommended',
  cardClickCheapest:'rails_connected_travel_cheapest',
  cardClickFastest:'rails_connected_travel_fastest',
  trainClick: 'rails_connected_travel_train_clicked',
  busClick: 'rails_connected_travel_bus_clicked',
  bottomSheetDismissClick: 'rails_connected_travel_bottomsheet_dismiss',
  connectedTrue:'connected_true',
  connectedNotShown: 'ct_notshown',
  connectedShown: 'ct_shown',
  onlyBusClick: 'rails_connected_travel_onlybus_clicked',
  waitistedTG: 'wl_green',
  waitlisted: 'wl_yellow',
  ctv2: 'ctv2',
  ctv1: 'ctv1',
  ctV2ViewClick: 'rails_connected_travel_view',
  twoTrainsTabClick: 'rails_connected_travel_tt',
  trainAndBusTabClick: 'rails_connected_travel_tb',
  ctV1Card: 'ct_c1',
  ctV2Card: 'ct_c2',
};

export const SCHEDULE_TATKAL_EVENTS = {
  landingReviewClick: 'mob_rail_landing_tatkalalerts_proceed',
  landingEditTravelerDetailsClick: 'mob_rail_landing_tatkalalerts_edit_passenger',
  landingRemoveAlertClick: 'mob_rail_landing_tatkalalerts_remove_alert',
  landingScheduleTatkalCardClick: 'mob_rail_landing_tatkalalerts_alert',
  scheduleTatkalSubmitClick: 'mob_rail_travellers_tatkalalerts_scheduled',
  listingScheduleTatkalContinueClick: 'mob_rail_listing_tatkalalerts_continue',
  listingScheduleTatkalBsCrossClick: 'mob_rail_listing_tatkalalerts_bs_cross',
  listingScheduleTatkalCardClick: 'mob_rail_listing_tatkalalerts_card_clicked_pos_',
  scheduleTatkalEnabled: 'st_t',
  scheduleTatkalDisabled: 'st_f',
  scheduleTatkalPageName: 'mob_rail_supertatkal_traveller',
  scheduleTatkalDoneClick: 'mob_rail_travellers_tatkalalerts_bs_done',
};

export const ODT_EVENTS = {
 odt_shown:'ODT',
 odt_not_shown:'NOODT',
 odt_chosen:'ODTchosen',
 odt_clicked:'rails_odt_nearbydates'
}

export const availabilityBucketOmnitureMapping = {
  zero: 'rails_za',
  low: 'rails_la',
  medium: 'rails_ma',
  high: 'rails_ha',
  very_high: 'rails_va',
};

//Venrac not required, so defined here
export const ENV_SWITCH = {
  TITLE: 'Rails API Config',
  ENTER_IP: 'Enter local IP address',
  ENTER_VALID_IP: 'Enter valid IP',
  SELECT_PWA: 'Select PWA Endpoint',
  SELECT_NODE: 'Select Node Endpoint',
  APPLY: 'Apply and Exit',
  PLACEHOLDER: 'xx.xx.xx.xx:yyyy',
  WIFI_NOTE: 'NOTE : Please make sure your device is connected to office network',
};

export const RAILS_DOWNTIME_TRIGGERED =  'rails_dowtime_triggered';
export const LISTING_DOWNTIME_ERROR_CODE = 'RAIL_TBS_AVAIL_10_CODE';
export const REVIEW_DOWNTIME_ERROR_CODE = 'RAILS_BOOKING_REVIEW_ERROR_10_CODE';
export const RAILS_BOOKING_REVIEW_ERROR_08_CODE = 'RAILS_BOOKING_REVIEW_ERROR_08_CODE';
export const RAILS_BOOKING_REVIEW_ERROR_07_CODE = 'RAILS_BOOKING_REVIEW_ERROR_07_CODE';
export const RAILS_DOWNTIME_CACHE = 'rails_downtime_cache';
export const RESPONSE_FROM_CACHE = 'CACHE';
export const ZERO_MINS = ' 00 min 00 second';
export const MULTI_SELECT = 'MULTI_SELECT';

export const irctcAccountUserNameAPI = async () => {
  try {
    const userLoggedIn = await isUserLoggedIn();
    if (!userLoggedIn) {
      return null;
    }
    const res = await fetch2(railsConfig.getIrctcUserName);
    const response = await res.json();
    return response?.primary_irctc_id;
  } catch (e) {
    console.log('error fetching irctc username', e);
  }
};

export const updateAccountUserNameAPI = async (userName) => {
  try {
    const userLoggedIn = await isUserLoggedIn();
    if (!userLoggedIn) {
      return null;
    }
    const body = {
      irctc_ids: [],
      primary_irctc_id: userName,
      sync_data: true,
    };
    fetch2(railsConfig.updateIrctcUserID, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  } catch (e) {
    console.log('error updating irctc username', e);
  }
};

export const getConnectedTravelCardProp61 = (optionCategoryType) => {
  try {
    switch (optionCategoryType) {
      case OPTION_CATEGORY_TYPE.Recommended:
        return LISTING_CONNECTED_TRAVEL_EVENTS.cardClickRecommended;
      case OPTION_CATEGORY_TYPE.Cheapest:
        return LISTING_CONNECTED_TRAVEL_EVENTS.cardClickCheapest;
      case OPTION_CATEGORY_TYPE.Fastest:
        return LISTING_CONNECTED_TRAVEL_EVENTS.cardClickFastest;
      default:
        return LISTING_CONNECTED_TRAVEL_EVENTS.cardClick;
    }
  } catch (err) {
    console.log('Error in getConnectedTravelCardProp61', err);
    return LISTING_CONNECTED_TRAVEL_EVENTS.cardClick;
  }
};

// App CMP (Campaign Management Platform) values list
export const APP_DEFAULT_CMP_VALUE = 'Direct';
export const APP_CMP_VALUES = ['CRM', 'SEO', 'SEM'];

export const RAILS_DEEPLINK = {
  LISTING:
    'mmyt://react/?page=railsListing&from={startCode}&to={endCode}&date={journeyDate}&alternate={alternate}&pnrNumber={pnr}&deeplink=true&source=RISxSell',
  LISTING_FROM_LTS:
    'mmyt://react/?page=railsListing&from={startCode}&to={endCode}&date={journeyDate}&deeplink=true&source=RISxSell',
  TRAVELLER:
    'mmyt://rails/?page=railsTravellerDeeplink&from={frmStnCode}&to={toStnCode}&departure={travelDate}&trainNumber={trainNumber}&classCode={classType}&quota={quota}&alternate={alternate}&boardingStnCode={boardingStationCode}&destStnCode={destStationCode}&boardingStnName={frmStnName}&destStnName={toStnName}&pnrNumber={pnr}&deeplink=true&source=RISxSell',
};

export const BUS_DEEPLINK = {
  LISTING_WEB:
    'https://www.makemytrip.com/mbus/rnw/busListingPage?from=${fromName}&from_code=${fromCode}&to=${toName}&to_code=${toCode}&departure=${dateStr}&openWidget=true&source=RISxSell',
};


export const NO_MEAL_OPTION = {
  key: "D",
  value: "No Food"
}

export const RAILS_SEO_REDIRECTION_PAGES = {
  LISTING: 'Listing',
  PNR: 'PNR',
  LIVE_STATUS: 'LiveStatus',
  LTS_DETAILS: 'LTS-Details',
  RAILS_BUS_COMMON_LANDING: 'RailsBusCommonLanding',
  WEBVIEW: 'WebView',
};

export const AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES = {
  INITIALISE: 'INITIALISE',
  UPDATE: 'UPDATE',
};

export const SEATLOCK_LOTTIE = 'SEATLOCK_LOTTIE';
export const seatLockConfig = {
  code: 'SEATLOCK_LOTTIE',
  title: 'SEATLOCK_LOTTIE',
  description: '',
  msg: {
    text: null,
    fontColor: '',
    backgroundColor: '',
  },
  icon: '',
  link: 'https://www.makemytrip.com/promos/gt-book-train-ticket-171023.html',
  borderColor: '',
  backgroundColor: '',
  prop61: 'mob_rail_listing_seatlock_banner_clicked',
};

export const TERMS_AND_CONDITIONS_URL =
  'https://www.makemytrip.com/promos/gt-book-train-ticket-171023.html';
export const TERMS_AND_CONDITIONS_HEADER_TEXT = 'Terms and Conditions';
export const OK = 'OKAY, GOT IT!';
export const SEAT_LOCK = 'Seat Lock';
export const SEAT_LOCK_IMAGE_URI =
  'https://go-assets.ibcdn.com/u/MMT/images/1719314347823-seat_lock_discount.webp';
export const HOW_SEAT_LOCK_WORKS_IMAGE_URI =
  'https://go-assets.ibcdn.com/u/MMT/images/1719314598163-how_seat_lock_works.webp';
export const FOOD_ICON =
  'https://go-assets.ibcdn.com/u/MMT/images/1748794706992-mealsBox.webp';
export const DONE_IMAGE_SOURCE = require('@mmt/legacy-assets/src/rails/done.webp');
export const CANCEL_IMAGE_SOURCE = require('@mmt/legacy-assets/src/rails/cancel.webp');
export const WHITE_BACK_ARROW_IMAGE_SOURCE = require('@mmt/legacy-assets/src/white_backarrow.webp');

export const RAILS_SEATLOCK_CLICKED = 'mob_rail_listing_seatlock_banner_clicked';
export const SEATLOCK_EVAR_97 = 'sl_li_';

export const RETRY_ACTION = 'RETRY';
export const GO_BACK = 'Go Back';

export const RIS_PREMIER_EXPAND = 'mob_rail_landing_expand_RIS';
export const RIS_PREMIER_COLLAPSE = 'mob_rail_landing_collapse_RIS';

export const RAIL_ELITE_DEAL_CLICKED = 'mob_prem_landing_rail_EliteDeal_Clicked';

export const RAIL_USER_ADDRESS_AUTHORIZATION = 'h4nhc9jcgpAGIjp';
export const RAIL_USER_ADDRESS_API_KEY = 'GROUND-RAILS-718152114418191219';

export const DISCOUNT_PLACEHOLDER = '{discount}';

export const RELFOOD_URL = 'https://makemytrip.relfood.com';
export const MAKEMYTRIP_ZOMATO_URL = 'https://www.makemytrip.com/railways/food';
export const MEALS_STATIONS_URL = 'https://www.makemytrip.com/railways/food/stations';
export const RELFOOD_PNR_URL = 'https://makemytrip.relfood.com/Search?val={pnrNumber}';

export const LOGIN_TO_AVAIL_KEY = 'login_to_avail';

export const HDFC_SMART_BUY_DNS = 'alliances.makemytrip';

export const IRCTC_TATKAL_AADHAAR_NOT_VERIFIED_ERROR = 'IRCTC_TATKAL_AADHAAR_NOT_VERIFIED_ERROR';
export const LINK_AADHAR_TEXT = 'Link your Aadhar with IRCTC ID for Tatkal Booking';
export const AADHAR_MARKETING_LINK =
  'https://www.makemytrip.com/promos/aadhaar-link-tatkal-bookings.html';


export const RAILS_VERIFICATION_FLOW_OMNITURE_EVENTS = {
  AADHAAR_GENERATE_OTP_CLICK: 'Aadhaar_Generate_OTP_Click',
  AADHAAR_GENERATE_OTP_CLOSE: 'Aadhaar_Generate_OTP_Close',
  AADHAAR_VERIFY_LINK_OTP_CHECK: 'Aadhaar_Verify_Link_OTP_Check',
  AADHAAR_VERIFY_LINK_OTP_UNCHECK: 'Aadhaar_Verify_Link_OTP_Uncheck',
  AADHAAR_VERIFY_OTP: 'Aadhaar_Verify_OTP',
  AADHAAR_VERIFY_OTP_CLOSE: 'Aadhaar_Verify_OTP_Close',
  AADHAAR_VERIFY_OTP_CROSS: 'Aadhaar_Verify_OTP_cross',
  AADHAAR_VERIFY_OTP_RESENT: 'Aadhaar_Verify_OTP_Resent', // Will append attempt number
  AADHAAR_VERIFY_OTP_SUCCESSFUL: 'Aadhar_Verify_OTP_Successful',
  AADHAAR_VERIFY_OTP_NO_ATTEMPTS: 'Aadhar_Verify_OTP_No_Attempts',
  AADHAAR_VERIFY_OTP_TECHNICAL_ERROR: 'Aadhar_Verify_OTP_Technical_Error',
  AADHAAR_SUBMIT_OTP_CLICK: 'Aadhaar_Submit_OTP_Click',
  AADHAAR_RESEND_OTP_CLICK: 'Aadhaar_Resend_OTP_Click',
};

export const RAILS_VERIFICATION_FLOW_USER_VERIFIED = 'ot_r';

export const RAILS_VERIFICATION_FLOW_CONSTANTS = {
  ANIMATION_DURATION: 1000,
  DEFAULT_TIMER: 60,
  OTP_LENGTH: 6,
  ORGANIZATION: 'MakeMyTrip',
  CONTENT_TYPE: 'application/json',
  TIMER_INTERVAL: 1000,
  BACK_ARROW_URL: 'https://go-assets.ibcdn.com/u/MMT/images/1753869884536-mmtArrow.webp',

  TEXT: {
    OTP_PLACEHOLDER: 'Enter 6 digit OTP',
    OTP_LABEL: 'ENTER 6 DIGIT OTP',
    RESEND: 'RESEND',
    INVALID_OTP_ERROR: 'Please enter valid OTP',
    GENERIC_ERROR: 'Something went wrong. Please try again.',

    ERROR_GENERATING_OTP: 'Error generating OTP:',
    ERROR_VERIFYING_OTP: 'Error verifying OTP:',
    ERROR_RESENDING_OTP: 'Error resending OTP:',
  },

  ACTIONS: {
    CLOSE_BOTTOMSHEET: 'CLOSE_BOTTOMSHEET',
    GENERATE_AADHAAR_OTP: 'GENERATE_AADHAAR_OTP',
    BACK: 'BACK',
    SUBMIT_AADHAAR_OTP: 'SUBMIT_AADHAAR_OTP',
    CONTINUE_BOOKING: 'CONTINUE_BOOKING',
    CLOSE: 'CLOSE',
  },

  TEMPLATE_TYPES: {
    VERIFY_AADHAAR_OTP_FLOW: 'VERIFY_AADHAAR_OTP_FLOW',
    SIMPLE: 'SIMPLE',
  },
};

export const IRCTC_FETCH_PASSWORD_INFO =
  'We strongly recommend that you get a new IRCTC password now (via SMS) if you do not remember it.';

export const MOB_RAIL_TRAVELLERS_RESET_PWD = 'mob_rail_travellers_reset_pwd';
export const MOB_RAIL_TRAVELLERS_CLOSE_PWD = 'mob_rail_travellers_close_pwd';
export const MOB_RAIL_TRAVELLERS_RECEIVE_PWD = 'mob_rail_travellers_receive_pwd';
export const MOB_RAIL_TRAVELLERS_PWD_CROSS = 'mob_rail_travellers_pwd_cross';
export const MOB_RAIL_TRAVELLERS_BACK_PWD = 'mob_rail_travellers_back_pwd';
export const IRCTC_PROFILE_INCOMPLETE_REVIEW_ERROR_EVAR99 = 'ic_b';
export const RESET_PASSWORD_REVIEW_ERROR_EVAR99 = 'r_p';
export const RAILS_BOOKING_REVIEW_ERROR_04_CODE = 'RAILS_BOOKING_REVIEW_ERROR_04_CODE';
export const RAILS_BOOKING_REVIEW_PASSWORD_EXPIRED = 'RAILS_BOOKING_REVIEW_PASSWORD_EXPIRED';
export const RAILS_BOOKING_REVIEW_INCOMPLETE_IRCTC_PROFILE =
  'RAILS_BOOKING_REVIEW_INCOMPLETE_IRCTC_PROFILE';
export const RETRY_ALTERNATE_AVAILABILITY_BOOKING = 'RETRY_ALTERNATE_AVAILABILITY_BOOKING';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const GO_BACK_TO_BS = 'GO_BACK';


export const REVIEW_ERROR_CODE_TATKAL_BOTTOMSHEET = 'RAILS_ADVANCE_TATKAL_BOOKING_REVIEW_ERROR';
export const REVIEW_ERROR_CODE_ARP_BOTTOMSHEET = 'RAILS_ARP_BOOKING_REVIEW_ERROR';

export const PDT_TRAVELLER_NATIONALITY_EXPAND = 'rail_travellers_nationality_expand';
export const PDT_TRAVELLER_NATIONALITY_COLLAPSE = 'rail_travellers_nationality_collpase';
export const PDT_TRAVELLER_NATIONALITY_CHOSEN_PREFIX = 'rail_travellers_nationality_chosen_';
export const ERR_PASSPORT_REQUIRED = 'As per IRCTC, this is mandatory for Int. travellers';
export const ERR_DOB_REQUIRED = 'As per IRCTC, this is mandatory for International travellers';
export const ERR_AGE_DOB_MISMATCH = 'Wrong age as per given DOB';
export const ERR_PASSPORT_INVALID =
  'Passport number should be alphanumeric, ALL CAPS, 6–9 characters, and contain at least one digit.';
export const IRCTC_PASSPORT_MANDATORY = '*As per IRCTC, passport number is mandatory';
export const IRCTC_DOB_MANDATORY = '*As per IRCTC, DOB is mandatory';

// Nationality normalization utility function
export const normalizeNationality = (nationality, COUNTRIES) => {
  let nationalityNormalized = { code: 'IN', name: 'India' };
  try {
    if (nationality) {
      if (typeof nationality === 'string') {
        const wanted =
          nationality.trim().toLowerCase() === 'indian' ? 'india' : nationality.trim();
        const match = COUNTRIES.find((c) => c.name.toLowerCase() === wanted.toLowerCase());
        if (match) {
          nationalityNormalized = { code: match.code, name: match.name };
        }
      } else if (typeof nationality === 'object' && nationality.code && nationality.name) {
        nationalityNormalized = nationality;
      }
    }
  } catch (_e) {
    console.log('error normalizing nationality', _e);
  }
  return nationalityNormalized;
};


export const checkIfHdfcSmartBuy = () => {
  return window.location.href.includes(HDFC_SMART_BUY_DNS);
};

export const showSearchBackButton = () => {
return !window.location.href.includes('alliances.makemytrip.com/railways/search') 

}